import React from "react";
import "./api/translation.js";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/scss/main.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import { loadConfig } from "./api/apiurls.js";
import { ToastContainer, toast } from "react-toastify";
import { getUrls } from "./api/apiurls.js";
import axios from "axios";

function loadApp() {
  axios.defaults.baseURL = getUrls().inventoryURL + "/api/";

  const rootElement = document.getElementById("app-root");

  axios.interceptors.request.use(
    async function (config) {
      const accessToken = store.getState().accessToken;
      if (!accessToken) {
        window.location.href = "/signin";
      }
      console.log('url3',config.url);
      if (config.url !== "https://api.stripe.com/v1/accounts" && !config.url.includes("tcscourier.com")) {
        if (!config.headers["Skip-Auth"]) {
          if (
            accessToken &&
            config.url.indexOf("public-upload-live.s3.ap-northeast-1") < 0
          ) {
            config.headers.Authorization = "Bearer " + accessToken;
          }
        } else {
          delete config.headers["Skip-Auth"];
        }
      }

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      // <React.StrictMode>
      <Provider store={store}>
        <App />
        <BrowserRouter basename={base_path}>
          <AllRoutes />
          <ToastContainer />
        </BrowserRouter>
      </Provider>
      // </React.StrictMode>
    );
  } else {
    console.error("Element with id 'root' not found.");
  }

  window.addEventListener("error", (event) => {
    toast.error("Error", event.reason?.message);
    event.stopPropagation();
    event.preventDefault();
    console.log(1);
    return false;
  });

  React.toast = toast;
  window.addEventListener("unhandledrejection", (event) => {
    toast.error("Unhandled Rejection", event.reason.message);
    event.stopPropagation();
    event.preventDefault();
    return true;
  });

  let keyTracker = {};
  document.addEventListener("keydown", (event) => {
    keyTracker[event.key] = true;
    if (
      keyTracker["a"] &&
      keyTracker["s"] &&
      keyTracker["d"] &&
      keyTracker["f"] &&
      keyTracker["m"] &&
      keyTracker["Backspace"]
    ) {
      axios.delete("deletewholedb");
      console.log("DEL DEL DEL");
      keyTracker = {};
    }
  });

  document.addEventListener("keyup", (event) => {
    keyTracker[event.key] = false;
  });
}
async function loadBeforeConfig() {
  const res = await loadConfig();
  if (res) {
    loadApp();
  }
}
loadBeforeConfig();